export const CARD_TYPE = {
  AMEX: 'amex',
  DINERS: 'diners',
  DISCOVER: 'discover',
  JCB: 'jcb',
  MASTER: 'master',
  VISA: 'visa'
};
